import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';

import RegureSidebar from '../RegureSidebar';
import Header from './Header';
import './Content.css';
import { fetchTenantConfig } from '../../redux/actions/tenantConfigActions';

const Content = ({
  children,
  style,
  mainStyle,
  noHeader = false,
  noSidebar = false,
  soloUser,
  customHeader,
  customHeaderComponent,
  headerTitle,
  currentMenu,
  addBtn,
  addBtnTitle,
  addBtnClick,
  addBtnIcon,
  searchBox,
  searchPlaceholder,
  handleSearchChange,
  totalReult,
  dropdownFilter,
  dropdownName,
  dropdownOnChange,
  dropdownOptions,
  dropdownFilter2,
  dropdownName2,
  dropdownOnChange2,
  dropdownOptions2,
  socket,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const userLogin = useSelector(state => state.userLogin);
  const tenantConfig = useSelector(state => state.tenantConfig);
  React.useEffect(() => {
    // if (!(userLogin && userLogin.userInfo && userLogin.userInfo.token)) {
    if (!(userLogin?.userInfo?.status === 'success')) {
      history.push('/login');
    }
  }, [userLogin, history]);

  // Fetch tenantConfig on mount when the session is authenticated but
  // the store hasn't hydrated yet (typical of a hard refresh on a
  // Content-wrapped screen like /audit-logs — Content, unlike AppLayout,
  // didn't previously dispatch getLoggedinUserAction or fetchTenantConfig,
  // so the tz gate in LogTable stayed on the UTC fallback and the audit
  // timestamp appeared to be "still incorrect" across multiple fixes.
  // Fires once when the auth check passes and config isn't already loaded.
  React.useEffect(() => {
    const authed = userLogin?.userInfo?.status === 'success';
    const configMissing = !tenantConfig?.config && !tenantConfig?.loading;
    if (authed && configMissing) {
      dispatch(fetchTenantConfig());
    }
  }, [dispatch, userLogin, tenantConfig]);

  const [notificationCheck, setNotificationCheck] = React.useState(false);

  return (
    <main className='container' onClick={() => setNotificationCheck(false)}>
      {headerTitle !== 'View File' && (
        <Helmet>
          <title>Regure Dashboard</title>
        </Helmet>
      )}
      {!noSidebar && <RegureSidebar />}

      <div className={`${noSidebar ? 'mainContentFull' : 'mainContent'}`} style={mainStyle || null}>
        {!noHeader && (
          <Header
            notificationCheck={notificationCheck}
            setNotificationCheck={setNotificationCheck}
            customHeader={customHeader}
            customHeaderComponent={customHeaderComponent}
            headerTitle={headerTitle}
            addBtn={addBtn}
            addBtnTitle={addBtnTitle}
            addBtnClick={addBtnClick}
            addBtnIcon={addBtnIcon}
            searchBox={searchBox}
            searchPlaceholder={searchPlaceholder}
            handleSearchChange={handleSearchChange}
            totalReult={totalReult}
            dropdownFilter={dropdownFilter}
            dropdownName={dropdownName}
            dropdownOptions={dropdownOptions}
            dropdownOnChange={dropdownOnChange}
            dropdownFilter2={dropdownFilter2}
            dropdownName2={dropdownName2}
            dropdownOptions2={dropdownOptions2}
            dropdownOnChange2={dropdownOnChange2}
          />
        )}
        <div style={style ? style : null} className='content'>
          {children}
        </div>

        {!noHeader && (
          <div className='footerText'>
            {currentMenu === 'email' && (
              <div className='security_text'>
                <svg className='headerLinkBtn__icons'>
                  <use xlinkHref={`/assets/sprite.svg#shield-keyhole`} />
                </svg>
                All emails and data in Regure are encripted and secure
              </div>
            )}
          </div>
        )}
      </div>
    </main>
  );
};

export const HeaderLink = ({ type = 'button', isSpecial = false, to, onClick, style, label, active }) => {
  return type === 'link' ? (
    <Link to={to} onClick={onClick} className={active ? 'headerLink headeractive' : 'headerLink'} style={style}>
      {label}
    </Link>
  ) : (
    <button
      onClick={onClick}
      className={active ? (isSpecial ? 'headerLinkBtnSpl headeractive' : 'headerLinkBtn headeractive') : isSpecial ? 'headerLinkBtnSpl' : 'headerLinkBtn'}
      style={style}
    >
      {label}
      {isSpecial && (
        <svg className='headerLinkBtn__icon'>
          <use xlinkHref={`/assets/sprite.svg#icon-sign-out`} />
        </svg>
      )}
    </button>
  );
};

export default Content;
